// extracted by mini-css-extract-plugin
module.exports = {"pageSectionWrapper":"PageSection_pageSectionWrapper__1w64V","pageSection":"PageSection_pageSection__2zfBi","pageSection-background":"PageSection_pageSection-background__1WIZi"};